import { html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { query, property } from 'lit/decorators.js';
import { Switch } from '@material/web/switch/internal/switch.js';
import '@material/web/switch/switch.js';

export class IxSwitch extends LitElement {
  @query('md-switch') readonly component!: Switch;

  /**
   * Disables the switch and makes it non-interactive.
   */
  @property({ type: Boolean, reflect: true }) disabled = false;

  /**
   * Puts the switch in the selected state and sets the form submission value to
   * the `value` property.
   */
  @property({ type: Boolean }) selected = false;

  /**
   * Shows both the selected and deselected icons.
   */
  @property({ type: Boolean }) icons = false;

  /**
   * Shows only the selected icon, and not the deselected icon. If `true`,
   * overrides the behavior of the `icons` property.
   */
  @property({ type: Boolean, attribute: 'show-only-selected-icon' })
  showOnlySelectedIcon = false;

  /**
   * When true, require the switch to be selected when participating in
   * form submission.
   *
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#validation
   */
  @property({ type: Boolean }) required = false;

  /**
   * The HTML name to use in form submission.
   */
  @property({ type: String }) name: string | undefined = undefined;

  /**
   * The value associated with this switch on form submission. `null` is
   * submitted when `selected` is `false`.
   */
  @property({ type: String }) value = 'on';

  protected createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <md-switch
        style="filter: drop-shadow(0 0px 1px #00000090);"
        name=${ifDefined(this.name)}
        value=${this.value}
        ?disabled=${this.disabled}
        ?selected=${this.selected}
        ?icons=${this.icons}
        ?show-only-selected-icon=${this.showOnlySelectedIcon}
        ?required=${this.required}
      >
      </md-switch>
    `;
  }
}
